import React, { useContext } from "react";
import BreakpointContext from "../../contexts/breakpointContext";
import DraftStateContext from "../../contexts/draftStateContext";
import TabSection from "../ui/TabSection";
import Admin from "./Admin";
import Chat from "./Chat";
import ControlledTabSection from "./ControlledTabSection";
import Grid from "./Grid";
import Header from "./Header";
import Info from "./Info";
import Picks from "./Picks";
import Players from "./Players";
import Rosters from "./Rosters";
import SelectedPlayer from "./SelectedPlayer";
import WatchList from "./WatchList";

export default function DraftSmall() {
  const breakpoints = useContext(BreakpointContext);
  const draftState = useContext(DraftStateContext);

  return (
    <div>
      <Admin />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          backgroundColor: "white",
          color: "black",
          padding: "0.25rem",
          borderRadius: "1rem",
        }}
      >
        <Header />
        <div style={{ display: "flex" }}>
          <div style={{ width: "58%", marginRight: "2%" }}>
            {!draftState.info.hasEnded ? (
              <TabSection
                labels={["Chat", "Watch List"]}
                panels={[<Chat />, <WatchList />]}
              />
            ) : (
              <TabSection labels={["Chat"]} panels={[<Chat />]} />
            )}
          </div>
          <div
            style={{ display: "flex", flexDirection: "column", width: "40%" }}
          >
            <Info />
            {!draftState.info.hasEnded ? <SelectedPlayer /> : null}
          </div>
        </div>

        {breakpoints.sm ? (
          <ControlledTabSection
            labels={["Players", "Picks", "Teams", "Grid"]}
            panels={[<Players />, <Picks />, <Rosters />, <Grid />]}
          />
        ) : (
          <ControlledTabSection
            labels={["Players", "Picks", "Teams"]}
            panels={[<Players />, <Picks />, <Rosters />]}
          />
        )}
      </div>
    </div>
  );
}
